import Styles from './ReviewRequestCard.module.scss'
import { InformalFeedbackRequest } from 'api/clients/InformalFeedbackRequestsClient'
import { ReactNode } from 'react'
import { ReviewSummaryModal } from 'components/ReviewSummaryModal/ReviewSummaryModal'
import { useModals } from 'almanac-ui/Modal'
import { Pressable } from '@react-aria/interactions'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { ReviewSummaryDrawer } from 'components/ReviewSummaryModal/ReviewSummaryDrawer'

interface Props {
  request: InformalFeedbackRequest
  children: ReactNode
}

export const Content = observer(({ request, children }: Props) => {
  const { openModal } = useModals()
  const { isMobile } = useResponsiveDesign()
  const { drawersStore } = useRootStore()

  const handleClick = () => {
    if (isMobile) {
      drawersStore.openDrawer(ReviewSummaryDrawer, { request })
    } else {
      openModal(ReviewSummaryModal, { requestId: request.id })
    }
  }

  return (
    <Pressable onPress={handleClick}>
      <div className={Styles.content}>{children}</div>
    </Pressable>
  )
})
